import React from 'react';
import '../App.css';
import './HeroSection.css';

function HeroS() {
return (
  <div className="hero-container">
    <h1>
      Membership Registration 
    </h1>
    <p>Join the ICFOSS Club for Innovation and Collaboration</p>
    
  </div>
);
}

export default HeroS;